var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 6.1998C13.991 6.1998 15.1998 4.99097 15.1998 3.4998C15.1998 2.00864 13.991 0.799805 12.4998 0.799805C11.0086 0.799805 9.7998 2.00864 9.7998 3.4998C9.7998 3.61274 9.80673 3.72406 9.8202 3.83335L5.37414 6.05638C4.88853 5.58794 4.22782 5.2998 3.4998 5.2998C2.00863 5.2998 0.799805 6.50864 0.799805 7.9998C0.799805 9.49097 2.00863 10.6998 3.4998 10.6998C4.22783 10.6998 4.88856 10.4117 5.37417 9.9432L9.8202 12.1662C9.80673 12.2755 9.7998 12.3869 9.7998 12.4998C9.7998 13.991 11.0086 15.1998 12.4998 15.1998C13.991 15.1998 15.1998 13.991 15.1998 12.4998C15.1998 11.0086 13.991 9.7998 12.4998 9.7998C11.7718 9.7998 11.1111 10.0879 10.6255 10.5564L6.1794 8.33335C6.19287 8.22406 6.1998 8.11274 6.1998 7.9998C6.1998 7.88685 6.19286 7.77552 6.1794 7.66621L10.6254 5.4432C11.111 5.91166 11.7718 6.1998 12.4998 6.1998Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.28a51a20c0d94dfa1ae6f08305553c3d.svg";
export { ForwardRef as ReactComponent };